export default "__VITE_ASSET__DRI9gmFL__"